/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdRateProps } from './type';

export const rateDefaultProps: TdRateProps = {
  defaultValue: 0,
  allowHalf: false,
  color: '#ED7B2F',
  size: '24px',
  count: 5,
  gap: 4,
  showText: false,
  texts: ['极差', '失望', '一般', '满意', '惊喜'],
};
